module.exports = __webpack_public_path__ + "media/images/icons/arrow-right-a7bebd312f37be380f8e3ad9f222231e.svg";